import axios from 'axios'

// state
export const state = {
  quests: [],
}

// getters
export const getters = {
}
// mutations
export const mutations = {
  fetchQuestsSuccess(state, quests) {
    state.quests = quests
  },
}
// actions
export const actions = {
  async fetchQuests({ commit, dispatch }) {
    try {
      const response = await axios.get(`quests`)
      commit('fetchQuestsSuccess', response)

      response.map(({ progress, quest: { id, method } }) => {
        commit(`quests/${method}/activateQuest`, { id, progress }, { root: true })
      })
      return response
    } catch (e) {

    }
  },
}
